import {
  StorefrontKey,
  getStorefrontOrigin,
} from "../../storefront/storefront";
import {
  COLOR_MODE_QUERY_PARAM_KEY,
  readColorModePreference,
} from "../../theme/colorMode";

const FALLBACK_PATH = "/auctions";
const BLOCKED_PREFIXES = ["/admin", "/superadmin", "/internal", "/api"];

// Conservative allowlist: only carry these across storefronts
export function isSafeToCarryPath(pathname: string): boolean {
  if (!pathname.startsWith("/")) return false;

  // Blocklist first
  const lower = pathname.toLowerCase();
  if (BLOCKED_PREFIXES.some((p) => lower === p || lower.startsWith(p + "/"))) {
    return false;
  }

  // Allow "/" exactly
  if (pathname === "/") return true;

  // Allow auctions list and one-level detail: /auctions or /auctions/:id
  // (Keeps it flexible for numeric ids or slugs; disallows deeper nesting.)
  if (/^\/auctions(\/[^/]+)?$/.test(pathname)) return true;

  // Allow a few universal pages (exact or subpaths)
  const ALLOWED_PREFIXES = ["/buy-bids", "/how-it-works", "/about"];
  if (
    ALLOWED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))
  ) {
    return true;
  }

  return false;
}

export function buildStorefrontSwitchUrl(targetKey: StorefrontKey): string {
  if (typeof window === "undefined") {
    // You can also choose to return getStorefrontOrigin(targetKey) in SSR contexts.
    throw new Error("buildStorefrontSwitchUrl must be called in the browser");
  }

  const currentUrl = new URL(window.location.href);
  const targetOrigin = getStorefrontOrigin(targetKey); // includes scheme + host (+ dev port)

  // Build a new URL from the target origin, then decide what to carry
  const nextUrl = new URL(targetOrigin);

  if (isSafeToCarryPath(currentUrl.pathname)) {
    nextUrl.pathname = currentUrl.pathname;
    nextUrl.search = currentUrl.search;
    nextUrl.hash = currentUrl.hash;
  } else {
    nextUrl.pathname = FALLBACK_PATH;
    nextUrl.search = "";
    nextUrl.hash = "";
  }

  nextUrl.searchParams.set(
    COLOR_MODE_QUERY_PARAM_KEY,
    readColorModePreference(),
  );

  return nextUrl.toString();
}
